export default function Projects() {
  return (
    <section id="projects" className="px-4 py-8">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-xl lg:text-2xl font-bold text-green-900 mb-6">施工実績</h2>
        <p className="text-sm text-green-600 mb-6 text-center">商業施設や工場、ビルなど様々な実績がございます</p>
        <div className="grid lg:grid-cols-2 gap-6">
          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <img 
              src="https://static.readdy.ai/image/54a81377d2a88f03463864bd512c4100/a18c6ac904e80f434a5b6dd5afcf3551.png" 
              alt="トヨタ工場保全工事" 
              className="w-full h-44 lg:h-48 object-cover object-center"
            />
            <div className="p-4">
              <h3 className="font-bold text-green-900 mb-2">トヨタ上郷工場、明知工場、貞宝工場 保全工事一式</h3>
              <div className="space-y-1 text-sm text-green-600">
                <p>2021年1月～</p>
                <p className="text-primary font-medium">強電一次側二次側ケーブル敷設、照明・ラック・配管工事、展示用ブース照明、空調設備更新など</p>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <img 
              src="https://static.readdy.ai/image/54a81377d2a88f03463864bd512c4100/abc4bcc0be378af26737f575b4bbab85.png" 
              alt="アドマテックス土岐プラント工事" 
              className="w-full h-44 lg:h-48 object-cover object-center"
            />
            <div className="p-4">
              <h3 className="font-bold text-green-900 mb-2">アドマテックス土岐 アルミナ増設プラント工事一式</h3>
              <div className="space-y-1 text-sm text-green-600">
                <p>2022年6月</p>
                <p>対応エリア:岐阜県土岐市</p>
                <p className="text-primary font-medium">アルミナ製造プラントの電気設備工事完了</p>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <img 
              src="https://static.readdy.ai/image/54a81377d2a88f03463864bd512c4100/3065a4ab40786c83870b1a7efecb074e.png" 
              alt="豊田市浄水町マンション工事" 
              className="w-full h-44 lg:h-48 object-cover object-center"
            />
            <div className="p-4">
              <h3 className="font-bold text-green-900 mb-2">豊田市浄水町 マンションフロア工事一式</h3>
              <div className="space-y-1 text-sm text-green-600">
                <p>2022年11月</p>
                <p>対応エリア:愛知県豊田市</p>
                <p className="text-primary font-medium">マンション全フロアの電気設備工事を担当</p>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <img 
              src="https://public.readdy.ai/ai/img_res/f13d07b819ce04d73c6f7f6c033057c8.jpg" 
              alt="森永製菓中京工場工事" 
              className="w-full h-44 lg:h-48 object-cover object-center"
            />
            <div className="p-4">
              <h3 className="font-bold text-green-900 mb-2">森永製菓中京工場 リフレッシュ工事及びギガキャスト新設工事</h3>
              <div className="space-y-1 text-sm text-green-600">
                <p>2023年8月</p>
                <p>対応エリア:愛知県</p>
                <p className="text-primary font-medium">工場設備更新と新設備の電気工事完了</p>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <img 
              src="https://static.readdy.ai/image/54a81377d2a88f03463864bd512c4100/d8d6f3f99b5deabcb40ab4fc35eead09.png" 
              alt="アイシン榎前工場工事" 
              className="w-full h-44 lg:h-48 object-cover object-center"
            />
            <div className="p-4">
              <h3 className="font-bold text-green-900 mb-2">アイシン榎前工場 二次側用ケーブル敷設工事一式</h3>
              <div className="space-y-1 text-sm text-green-600">
                <p>2024年4月</p>
                <p>対応エリア:愛知県</p>
                <p className="text-primary font-medium">工場内二次側ケーブル敷設工事を担当</p>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <img 
              src="https://readdy.ai/api/search-image?query=Three%20Japanese%20electrical%20workers%20in%20gray%20uniforms%20and%20blue%20safety%20helmets%20installing%20large%20HVAC%20electrical%20distribution%20panel%20on%20wall%2C%20team%20lifting%20heavy%20electrical%20equipment%20together%2C%20industrial%20facility%20with%20air%20conditioning%20units%20visible%2C%20collaborative%20installation%20work%2C%20well-organized%20construction%20site&width=600&height=300&seq=project206&orientation=landscape" 
              alt="兼房空調設備更新工事" 
              className="w-full h-44 lg:h-48 object-cover object-center"
            />
            <div className="p-4">
              <h3 className="font-bold text-green-900 mb-2">兼房 空調設備更新、ケーブル分電盤工事一式</h3>
              <div className="space-y-1 text-sm text-green-600">
                <p>2024年7月</p>
                <p>対応エリア:愛知県</p>
                <p className="text-primary font-medium">空調設備更新に伴う電気工事完了</p>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <img 
              src="https://static.readdy.ai/image/54a81377d2a88f03463864bd512c4100/af62bc0fabb47a19048feb9811f5aea5.png" 
              alt="碧海信用金庫豊田西支店工事" 
              className="w-full h-44 lg:h-48 object-cover object-center"
            />
            <div className="p-4">
              <h3 className="font-bold text-green-900 mb-2">碧海信用金庫豊田西支店 電気工事一式</h3>
              <div className="space-y-1 text-sm text-green-600">
                <p>2025年3月</p>
                <p>対応エリア:愛知県豊田市</p>
                <p className="text-primary font-medium">金融機関の電気設備工事を担当</p>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <img 
              src="https://readdy.ai/api/search-image?query=Japanese%20electrical%20team%20in%20yellow%20safety%20vests%20and%20orange%20helmets%20replacing%20large%20industrial%20transformer%20in%20heavy%20manufacturing%20factory%2C%20workers%20using%20crane%20to%20install%20massive%20electrical%20transformer%20equipment%2C%20steel%20manufacturing%20facility%20with%20heavy%20machinery%2C%20complex%20electrical%20upgrade%20project%2C%20industrial%20construction%20scene&width=600&height=300&seq=project208&orientation=landscape" 
              alt="トピー豊川工場更新工事" 
              className="w-full h-44 lg:h-48 object-cover object-center"
            />
            <div className="p-4">
              <h3 className="font-bold text-green-900 mb-2">トピー豊川工場 更新工事ケーブルトランス盤入れ替え工事</h3>
              <div className="space-y-1 text-sm text-green-600">
                <p>2025年5月</p>
                <p>対応エリア:愛知県豊川市</p>
                <p className="text-primary font-medium">トランス盤入れ替えとケーブル更新工事完了</p>
              </div>
            </div>
          </div>
        </div>
        <p className="text-sm text-green-600 mt-6 text-center">など</p>
      </div>
    </section>
  );
}